// extracted by mini-css-extract-plugin
module.exports = {"tabs":"MainTabs_tabs__3RVMt"};